import Vue from 'vue';

import { Component, Prop, Watch } from 'vue-property-decorator';
import template from './orderStatusBgColor.vue';
import util from '../../shared/util';
@Component({
    mixins: [template],
})
export default class OrderStatusBgColor extends Vue {
    @Prop()
    status: string;

    @Prop({ default: '' })
    form: string;

    @Prop({ default: 'f-12' })
    fz: string;

    @Prop({ default: false })
    isShowBg: boolean;

    @Prop({ default: '' })
    orderStatus: any;

    @Watch('orderStatus', { deep: true, immediate: true })
    getOrderStatus(val: any, oldVal: any) {
        this.privateOrderStatus = util.filterShipmentStage(
            val.stage,
            val.status,
            val.orderCreatedFromlh
        );
        if (this.privateOrderStatus == 'Pickup Created') {
            if (this.isShowBg) this.bgColor = '#fffbf0!important';
            else this.bgColor = 'none !important';
            this.color = '#eda800';
        }
        if (this.privateOrderStatus == 'Pickup Dispatched') {
            if (this.isShowBg) this.bgColor = '#ecfff5 !important';
            else this.bgColor = 'none !important';
            this.color = '#41a782';
        }
        if (this.privateOrderStatus == 'Pickup Completed') {
            if (this.isShowBg) this.bgColor = '#ffe6e0 !important';
            else this.bgColor = 'none !important';
            this.color = '#b3462e';
        }
        if (this.privateOrderStatus == 'In Transit') {
            if (this.isShowBg) this.bgColor = '#eefeff !important';
            else this.bgColor = 'none !important';
            this.color = '#3cd3dc';
        }
        if (this.privateOrderStatus == 'Out for Delivery') {
            if (this.isShowBg) this.bgColor = '#e9e0ff !important';
            else this.bgColor = 'none !important';
            this.color = '#a187e1';
        }
        if (this.privateOrderStatus == 'Pending Delivery') {
            if (this.isShowBg) this.bgColor = '#fff3ff !important';
            else this.bgColor = 'none !important';
            this.color = '#ff00ff';
        }
        if (this.privateOrderStatus == 'Delivered') {
            if (this.isShowBg) this.bgColor = '#c9eeff !important';
            else this.bgColor = 'none !important';
            this.color = '#08415C';
        }
    }
    bgColor: string = 'none !important';
    color: string = '';
    privateOrderStatus: any = '';
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./src/components/orderStatusBgColor/index.ts